import {XauditModel} from '../../../models/xaudit.model';

export class TdoChatDataModel extends XauditModel {
  ChatID: string;
  ConversationID: string;
  SenderUserID: string;
  ReceiverID: string;
  enumChatReceverTypeID: string;
  enumNotificationStatusID: string;
  Message: string;
}
